import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Inject } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

@Component({
  selector: 'app-support-chat',
  templateUrl: './support-chat.component.html',
  styleUrls: ['./support-chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('chatAnimation', [
      state('closed', style({
        transform: 'scale(0.8)',
        opacity: 0,
        visibility: 'hidden'
      })),
      state('open', style({
        transform: 'scale(1)',
        opacity: 1,
        visibility: 'visible'
      })),
      transition('closed <=> open', [
        animate('200ms ease-in-out')
      ])
    ])
  ]
})
export class SupportChatComponent {
  private isOpenSubject = new BehaviorSubject<boolean>(false);

  vm$ = this.isOpenSubject.asObservable().pipe(
    map(isOpen => ({
      isOpen
    }))
  );
  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside && this.isOpenSubject.value) {
      this.close();
    }
  }

  toggle() {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  close() {
    this.isOpenSubject.next(false);
  }

  openWhatsApp() {
    const phone = '551150285000';
    const message = encodeURIComponent('Olá, preciso de suporte na Splitpay.');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  }

  selectProfile(profile: string) {
    window.open(`https://splitpaybrasil.com.br/tutoriais/${profile}`, '_blank');
  }
}
